import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EquipmentSizeViewComponent } from './equipment-size-view/equipment-size-view.component';
import { EquipmentSizeFormComponent } from './equipment-size-form/equipment-size-form.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { EquipmentSizeRoutingModule } from './equipment-size-routing-module';



@NgModule({
  declarations: [
    EquipmentSizeViewComponent,
    EquipmentSizeFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatDialogModule,
    EquipmentSizeRoutingModule,
    FormsModule, ReactiveFormsModule
  ]
})
export class EquipmentSizeModule { }
